import { useEffect, useState } from "react";
import RepFinReportHeader from "./rep-fin-report-header";
import RepFinReportTotal from "./rep-fin-report-total";
import dayjs from "dayjs";
import { serverFetch } from "../../../server";
import { strDate2Server } from "../../../extensions/utils";
import { message } from "antd";
import { isMobile } from "../../../extensions/design";
import { ExcelDataProvider } from "../rep-excel-data-provider";
import { useLocalStorageFilter } from "@/extensions/use-local-storage-filter";

const reportTypes = [
  { value: 0, label: 'Сводно' },
  { value: 1, label: 'По дням' },
  { value: 7, label: 'По неделям' },
  { value: 31, label: 'По месяцам' },
];

// Финансовый отчет, состоящий из шапки и общего отчета
const RepFin = () => {
  const [filters, setFilters] = useLocalStorageFilter(
    'repFinFilter',
    () => ({
      dateFrom: dayjs(),
      dateTo: dayjs(),
      cash: [],
      reportType: reportTypes[0].value,
    }),
    (parsed) => {
      const { dateFrom, dateTo } = (() => {
        const savedDateEnd = parsed.dateTo ? dayjs(parsed.dateTo) : null;
        const defaultDateFrom = dayjs();
        const defaultDateEnd = dayjs();
        if (savedDateEnd && dayjs().endOf('day').diff(savedDateEnd, 'day') > 1) {
          return { dateFrom: defaultDateFrom, dateTo: dayjs().endOf('day') };
        } else if (savedDateEnd && savedDateEnd.isBefore(dayjs(), 'day')) {
          return { dateFrom: parsed.dateFrom ? dayjs(parsed.dateFrom) : defaultDateFrom, dateTo: dayjs().endOf('day') };
        }
        return { dateFrom: parsed.dateFrom ? dayjs(parsed.dateFrom) : defaultDateFrom, dateTo: savedDateEnd || defaultDateEnd };
      })();
      return {
        dateFrom: dateFrom,
        dateTo: dateTo,
        cash: parsed.cash || [],
        reportType: parsed.reportType ?? reportTypes[0].value,
      };
    },
    (filters) => ({
      dateFrom: filters.dateFrom?.format('YYYY-MM-DD'),
      dateTo: filters.dateTo?.format('YYYY-MM-DD'),
      cash: filters.cash || [],
      reportType: filters.reportType
    }),
  );

  const [loading, setLoading] = useState(false);
  const onFilterChange = (value) => {
    setFilters({...filters, ...value})}
  
  const [data, setData] = useState([]);

  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const getData = () => {
    setLoading(true);
    serverFetch("report/finance", {method: "POST", bodyData: {...filters, dateFrom: strDate2Server(filters.dateFrom), dateTo: strDate2Server(filters.dateTo) }})
      .then(data => {
        setData(data);
        setLoading(false);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      })
  }

  useEffect(getData, []);

  useEffect(() => {
    if (isMobile) {
      getData();
    }
  }, [filters]);

  const onRefresh = () => {
    getData();
    setRefreshTrigger((prev) => prev + 1);
  };
  
  return (
    <ExcelDataProvider>
      <RepFinReportHeader filters={filters} onFilterChange={onFilterChange} reportTypes={reportTypes} onRefresh={onRefresh} loading={loading}/>
      <RepFinReportTotal filters={filters} loading={loading} data={data} onRefresh={getData} refreshTrigger={refreshTrigger}/>
    </ExcelDataProvider>
  )
}

export default RepFin;